$(function() {
    const $selector = $('.js-selector'),
        $footerTitle = $('.js-footer-title');

    $selector.on('click', function() {
        $selector.not(this).removeClass('active');
        $(this).toggleClass('active');
    });

    if (window.matchMedia("(max-width: 480px)").matches) {
        $footerTitle.next().slideUp();
        $footerTitle.on('click', function() {
            $(this).toggleClass('open');
            $(this).next().slideToggle();
        });
    }

    $('.js-back-to-top-btn').click(function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
    });

    $('.js-providers-tables').before($('.js-providers-header'));
});